export function formatISOish(ts) { 
  try { 
    return new Date(ts).toLocaleString(); 
  } catch { 
    return ts; 
  } 
}

export function formatRelative(ts) {
  const d = new Date(ts).getTime();
  const diff = Date.now() - d;
  const sec = Math.max(1, Math.floor(diff / 1000));
  
  if (sec < 60) return `${sec} ${sec === 1 ? 'sec' : 'secs'} ago`;
  
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min} ${min === 1 ? 'min' : 'mins'} ago`;
  
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr} ${hr === 1 ? 'hour' : 'hours'} ago`;
  
  // Use decimal for days (after 24 hours)
  const days = Math.round((hr / 24) * 10) / 10;
  return `${days} ${days === 1 ? 'day' : 'days'} ago`;
}